import { Switch as MantineSwitch, type SwitchProps } from "@mantine/core";
import {
  type Control,
  type FieldValues,
  type Path,
  useController,
} from "react-hook-form";

interface Props<T extends FieldValues> extends SwitchProps {
  name: Path<T>;
  control: Control<T>;
}

function Switch<T extends FieldValues>({
  name,
  control,
  disabled,
  ...props
}: Props<T>) {
  const {
    field: { value, ...field },
  } = useController({
    name,
    control,
    disabled,
  });

  return <MantineSwitch {...props} {...field} value={value} checked={value} />;
}

export default Switch;
